import React from 'react'
import HeroSection from '../../molecules/HeroSection/HeroSection'
import OfferAndPromocodes from '../../templates/Homepage/OfferAndPromocodes/OfferAndPromocodes'
import Destinations from '../../templates/Homepage/Destinations/Destinations'
// import FeaturedPackages from '../../templates/Homepage/FeaturedPackages/FeaturedPackages'
// import Brands from '../../templates/Homepage/Brands/Brands'
import WhyChoosUs from '../../templates/Homepage/WhyChooseUs/WhyChooseUs'

const Home = () => {
  return (
    <>
      <HeroSection />
      <OfferAndPromocodes />
      <Destinations />
      {/* <FeaturedPackages /> */}
      <WhyChoosUs />
      {/* <Brands /> */}
    </>
  )
}

export default Home
